"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeAttributes = void 0;
function decodeAttributes(state) {
    const result = {};
    const decodedState = Buffer.from(state, 'base64').toString();
    const keyValues = decodedState.split('|');
    for (const keyValue of keyValues) {
        const [key, value] = keyValue.split('=');
        result[key] = value;
    }
    return result;
}
exports.decodeAttributes = decodeAttributes;
//# sourceMappingURL=index.js.map